﻿const _chaveSessionStorageGeoData = 'localizacaoGeoData';

export function setGeoData(geoData) {
    if (localStorage.getItem(_chaveSessionStorageGeoData)) {
        return;
    }

    if (geoData != null && geoData != undefined && geoData.cidade != undefined) {
        //Decodifica string
        let geoDataCidadeDecode = decodeURIComponent(geoData.cidade);
        //Retira caracteres ainda estranhos
        geoDataCidadeDecode = geoDataCidadeDecode.replace(/£/g, '').replace(/Ã/g, 'ã').replace(/Â/g, 'â').replace(/Ê/g, 'ê').replace(/Î/g, 'î').replace(/Ô/g, 'ô').replace(/Û/g, 'û').replace(/Á/g, 'á').replace(/É/g, 'é').replace(/Í/g, 'í').replace(/Ó/g, 'ó').replace(/Ú/g, 'ú');
        geoData.cidade = geoDataCidadeDecode;
        localStorage.setItem(_chaveSessionStorageGeoData, JSON.stringify(geoData));
    }
}

export function getGeoData() {
    if (!localStorage.getItem(_chaveSessionStorageGeoData)) {
        return { existe: false };
    }

    const geoDataParsed = JSON.parse(localStorage.getItem(_chaveSessionStorageGeoData));
    const nomeCidade = `${geoDataParsed.cidade}, ${geoDataParsed.regiaoCodigo}, ${geoDataParsed.pais}`;

    return { existe: true, data: geoDataParsed, cidadeCompleta: nomeCidade };
}